/* tslint:disable */

declare var Object: any;
export interface SFGenerateLeaveBalanceInterface {
  "id"?: number;
}

export class SFGenerateLeaveBalance implements SFGenerateLeaveBalanceInterface {
  "id": number;
  constructor(data?: SFGenerateLeaveBalanceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFGenerateLeaveBalance`.
   */
  public static getModelName() {
    return "SFGenerateLeaveBalance";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFGenerateLeaveBalance for dynamic purposes.
  **/
  public static factory(data: SFGenerateLeaveBalanceInterface): SFGenerateLeaveBalance{
    return new SFGenerateLeaveBalance(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFGenerateLeaveBalance',
      plural: 'sfgenerateleavebalances',
      path: 'sfgenerateleavebalances',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFGenerateLeaveBalance.ts